module.exports = __webpack_public_path__ + "static/img/solution_banner_bg.62e9ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/solution_banner_bg.png
// module id = dwqk
// module chunks = 34